import { filter, isNil } from 'lodash';

import type { IPrismicSlice } from '@/types';

type SliceLike = {
  primary?: { active?: boolean };
  slice_type?: string;
};

export type ExtractBannerAreaSliceOptions = {
  /** When false, no slice is promoted to the banner area (e.g. general_landing enable_banner). */
  enabled?: boolean;
};

export type ExtractBannerAreaSliceResult = {
  bannerAreaSlice: IPrismicSlice[];
  bodySlices: IPrismicSlice[];
};

const asSliceLike = (slice: IPrismicSlice): SliceLike => slice as SliceLike;

const buildBannerAreaResult = (
  list: IPrismicSlice[],
  promotedSlice: IPrismicSlice,
): ExtractBannerAreaSliceResult => ({
  bannerAreaSlice: [promotedSlice],
  bodySlices: filter(list, slice => slice !== promotedSlice && !isNil(slice)),
});

export const extractBannerAreaSlice = (
  slices: Iterable<unknown> | null | undefined,
  options?: ExtractBannerAreaSliceOptions,
): ExtractBannerAreaSliceResult => {
  const list = (slices ? [...slices] : []) as IPrismicSlice[];

  if (options?.enabled === false || !list.length) {
    return { bannerAreaSlice: [], bodySlices: list };
  }

  const activeBanner = list?.find(slice => {
    const { slice_type, primary } = asSliceLike(slice);
    return slice_type === 'banner' && primary?.active;
  });

  if (activeBanner) {
    return buildBannerAreaResult(list, activeBanner);
  }

  const firstActiveSlice = list?.find(
    slice => asSliceLike(slice).primary?.active === true,
  );

  if (firstActiveSlice) {
    return buildBannerAreaResult(list, firstActiveSlice);
  }

  return { bannerAreaSlice: [], bodySlices: list };
};
